import * as types from "./constant"

export const getUserStart = () => {
  return {
    type: types.GET_SU_USER_START,
  }
}
export const getUserSuccess = (payload) => {
    return {
        type: types.GET_SU_USER_SUCCESS,
        payload:payload
    }
}
export const getUserFail = (payload) => {
    return {
        type: types.GET_SU_USER_FAILED,
        payload:payload
    }
}
export const getUserReset = () => {
    return {
        type: types.GET_SU_USER_RESET
    }
}


// Employee Details : 

export const getEmpStart = (payload) => {
    return {
      type: types.GET_SU_EMP_START,
      payload:payload
    }
  }
  export const getEmpSuccess = (payload) => {
      return {
          type: types.GET_SU_EMP_SUCCESS,
          payload:payload
      }
  }
  export const getEmpFail = (payload) => {
      return {
          type: types.GET_SU_EMP_FAILED,
          payload:payload
      }
  }
  export const getEmpReset = () => {
      return {
          type: types.GET_SU_EMP_RESET
      }
  }

  // SUBSCRIPTION :
  export const getSubsPlanStart = (payload) => {
    return {
      type: types.GET_SU_SUBS_START,
      payload:payload
    }
  }
  export const getSubsPlanSuccess = (payload) => {
      return {
          type: types.GET_SU_SUBS_SUCCESS,
          payload:payload
      }
  }
  export const getSubsPlanFail = (payload) => {
      return {
          type: types.GET_SU_SUBS_FAILED,
          payload:payload
      }
  }
  export const getSubsPlanReset = () => {
      return {
          type: types.GET_SU_SUBS_RESET
      }
  }


  // SUBSCRIPTION FOR ALL USERS 
  export const getUserSubsPlanStart = (payload) => {
    return {
      type: types.GET_SU_SUBS_USERS_START,
      payload:payload
    }
  }
  export const getUserSubsPlanSuccess = (payload) => {
      return {
          type: types.GET_SU_SUBS_USERS_SUCCESS,
          payload:payload
      }
  }
  export const getUserSubsPlanFail = (payload) => {
      return {
          type: types.GET_SU_SUBS_USERS_FAILED,
          payload:payload
      }
  }
  export const getUserSubsPlanReset = () => {
      return {
          type: types.GET_SU_SUBS_USERS_RESET
      }
  }